import {
  communicationDocumentDownloadSelectorConfig,
  communicationsDataSelectorConfig,
} from './communications'

export const selectorsConfig = {
  ...communicationsDataSelectorConfig,
  ...communicationDocumentDownloadSelectorConfig,
}
